export default "__VITE_ASSET__Ckh4rLff__"